import { CurrencyNumber, DateTimeString, GuidString } from "../../BrandedTypes";
import VatPrice from "../../VatPrice";
import Member from '../../Member';
import Retailer from "./Retailer";

export const CylinderIdentityArray = ['13kgCommercial', '19kgCommercial','47kgCommercial','13kgPatio'] as const
export type CylinderIdentity = typeof CylinderIdentityArray[number];

export  const CylinderDescription = (identity: CylinderIdentity) =>  {

    switch(identity){
        case '13kgCommercial':
            return '13kg Red Propane Cylinder'
        case '13kgPatio':
            return '13kg Green Patio Cylinder'
        case '19kgCommercial':
            return '19kg Red Propane Cylinder'
        case '47kgCommercial':
            return '47kg Red Propane Cylinder'
        default:
            return 'Unknown'
    }
}


export type ClaimStatus = 'Pending' | 'Rejected' | 'Approved';

export type AllTotals = {
    totals13kgCommercial: VatPrice,
    totals13kgPatio: VatPrice,
    totals19kgCommercial: VatPrice,
    totals47kgCommercial: VatPrice,
    totalOfTotals: VatPrice,
    quantity: number,
}

export type CylinderPuchaseDetailsWithVat = {
    quantity: number,
    pricePerCylinder: CurrencyNumber,
    vatIncluded: boolean,
    cylinderIdentity: CylinderIdentity,
    vatPercentage: number,
}

type Claim = {
    id: GuidString,
    memberAccount: Member,
    retailer: Retailer,
    vatNumber: string,
    purchaseDate: DateTimeString,
    receiptNumber: string,
    purchaseDetails: CylinderPuchaseDetailsWithVat[],
    receiptImageLocation: string,
    claimReference: string,
    fraudFlags: string[],
    lastActioned: DateTimeString,
} & ({
    claimStatus: 'Pending',
    calorEmployee: null,
    rejectionReasons: null,
    notes: null,
} | {
    claimStatus: 'Approved',
    calorEmployee: string,
    rejectionReasons: null,
    notes: null,
} | {
    claimStatus: 'Rejected',
    calorEmployee: string
    rejectionReasons: string[],
    notes: string,
})

export default Claim;